import type { ReactNode } from "react";
import { cn } from "./cn";

export type RozetTonu = "notr" | "bilgi" | "onay" | "uyari" | "hata";

export interface RozetProps {
  ton?: RozetTonu;
  /**
   * Ton onune konan isaret.
   *
   * ================================================================
   * VARSAYILAN YOK — VE BU BIR DUZELTME
   * ================================================================
   * Ilk yazimda her tona bir varsayilan isaret koymustum ("renk tek
   * basina anlam tasimaz" kuralindan). Kural dogru ama uygulamasi
   * FAZLA GENISTI: o kural, bilginin YALNIZCA renkle kodlandigi
   * durumlar icin.
   *
   * Bu arayuzdeki rozetlerin neredeyse hepsinde durum ZATEN METINDE
   * yaziyor — "Gecikmis", "Aktif", "Kritik". Metin varken renk
   * yalnizca destek; ustune bir de sembol koymak 45 rozetin hepsine
   * gurultu eklemek olurdu ve "11. sinif" gibi notr bir etikete
   * anlamsiz bir nokta dusurdu.
   *
   * Isaret artik ISTEGE BAGLI: metin durumu SOYLEMIYORSA (orn. yalniz
   * bir sayi ya da kisaltma) cagiran taraf `isaret` veriyor.
   */
  isaret?: ReactNode;
  children: ReactNode;
  className?: string;
}

const TON: Record<RozetTonu, string> = {
  notr: "bg-notr-100 text-notr-700 ring-notr-200",
  bilgi: "bg-marka-50 text-marka-700 ring-marka-100",
  onay: "bg-onay-50 text-onay-700 ring-onay-200",
  // Uyari metni `uyari-800`: `uyari-500` sari-turuncu ve acik zeminde
  // WCAG AA'nin altinda kaliyor (bkz. tokens.css).
  uyari: "bg-uyari-50 text-uyari-800 ring-uyari-200",
  // `hata-700`, `hata-500` DEGIL: teslim paketi olctu, `hata-500` kendi
  // acik kirmizi zemininde 4,19 veriyor ve AA'nin altinda kaliyor.
  hata: "bg-hata-50 text-hata-700 ring-hata-200",
};

/**
 * ROZET — durum etiketi.
 *
 * ================================================================
 * YARICAP `radius-rozet` — VE BU BIR GERI ADIM DEGIL, AYRIM
 * ================================================================
 * Onceki hali `rounded-alan` idi ve gerekcesi suydu: tam yuvarlak
 * rozetler "sayac" gibi okunur, bu ekranlarda gercek sayaclar da var.
 *
 * Teslim paketi ayni sorunu BASKA yerden cozuyor ve cozumu daha
 * guclu: bu arayuzde rozetle karisan sey sayac degil BILGI BANDI —
 * ikisi de acik zemin + ince halka + koyu metin tasiyor ve envanter
 * 134 bant ile 52 rozet sayiyor. Onlari ayiran tek gorsel isaret
 * yaricap: "Bilgi bandi ile durum rozetini ayiran sey yaricap; rozet
 * `radius-rozet` tasir." Bant `radius-alan`da kaliyor.
 *
 * Sayacla karisma riski kalkti cunku sayaclar cizimde rozet degil:
 * kendi tipografileri ve kart baglamlari var (`DurumKartlari.dc.html`).
 */
export function Rozet({ ton = "notr", isaret, children, className }: RozetProps) {
  return (
    <span
      className={cn(
        "rounded-rozet inline-flex items-center gap-1 px-2.5 py-0.5",
        "text-xs font-medium ring-1 ring-inset",
        TON[ton],
        className,
      )}
    >
      {isaret && (
        <span aria-hidden="true" className="leading-none">
          {isaret}
        </span>
      )}
      {children}
    </span>
  );
}
